import React from 'react';

import GetUserDiscounts from '@src/api/GetUserDiscounts';
import { generateDiscount } from '@src/factories';
import useAxiosRequestConfig from '@src/hooks/useAxiosRequestConfig';
import useFlatList from '@src/hooks/useFlatList';
import { Discount } from '@src/types';

const useUserDiscounts = () => {
  const axiosRequestConfig = useAxiosRequestConfig();

  const makeRequest = React.useCallback(async (): Promise<Discount[]> => {
    const response = await GetUserDiscounts(axiosRequestConfig);
    return response.data.discounts.map((post) => generateDiscount(post));
  }, [axiosRequestConfig]);

  return useFlatList(makeRequest);
};

export default useUserDiscounts;
